var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { UrlHelper } from '../../../helper/UrlWrapper';
import CommonService from '../../../api/CommonService';
import GoodService from '../../../api/GoodService';
import PurchaseReportForUpperSupService from '../../../api/PurchaseReportForUpperSupService';
var initFormData = {
    dimension: 1,
    type: 1,
    s_time: moment().subtract(6, 'days').format('YYYY-MM-DD'),
    e_time: moment().format('YYYY-MM-DD'),
    keyword: '',
};
var BillHeader = (function (_super) {
    __extends(BillHeader, _super);
    function BillHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = __assign({}, initFormData);
        _this.goods_type_ids = [];
        _this.business_ids = [];
        _this.supplier_upper_ids = [];
        _this.dimensionList = [
            { name: '单价', id: 1 },
            { name: '金额', id: 2 },
        ];
        _this.typeList = [
            { name: '单品', id: 1 },
            { name: '单品单供应商', id: 2 },
            { name: '单品多供应商', id: 3 },
        ];
        _this.shopList = [];
        _this.categoryData = [];
        _this.supplierList = [];
        return _this;
    }
    BillHeader.prototype.normalizerShop = function (node) {
        return {
            id: node.id,
            label: node.name,
            children: node.children,
        };
    };
    BillHeader.prototype.normalizerGoodType = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    BillHeader.prototype.normalizerSupplier = function (node) {
        return {
            id: node.supplier_upper_id,
            label: node.supplier_upper_name,
            children: node.children,
        };
    };
    BillHeader.prototype.watchshop_id = function (newValue, oldValue) {
        if (newValue === 1) {
            this.business_ids = [];
            this.supplier_upper_ids = [];
        }
    };
    BillHeader.prototype.created = function () {
        this.service = PurchaseReportForUpperSupService.getInstance();
        this.commonService = CommonService.getInstance();
        this.goodService = GoodService.getInstance();
        this.type === 1 ? this.getSupplierupper() : this.getCustomer();
        this.getCategory();
        if (this.type === 2) {
            this.typeList = [
                { name: '单品', id: 1 },
                { name: '单品单客户', id: 2 },
                { name: '单品多客户', id: 3 },
            ];
        }
    };
    BillHeader.prototype.search = function () {
        var filter = __assign({}, this.formData, { goods_type_ids: this.goods_type_ids.join(',') });
        if (this.type === 1) {
            filter.supplier_upper_ids = this.supplier_upper_ids.join(',');
        }
        else {
            filter.business_ids = this.business_ids.join(',');
        }
        this.$emit('search', filter);
    };
    BillHeader.prototype.reset = function () {
        this.goods_type_ids = [];
        this.business_ids = [];
        this.supplier_upper_ids = [];
        this.formData = __assign({}, initFormData);
    };
    BillHeader.prototype.exportData = function () {
        var url = "supplierclientapi/" + (this.type === 1 ? 'purchase_report' : 'sale_report') + "/price_analyze_export";
        url = UrlHelper.addParam(url, 'token', this.user.token);
        url = UrlHelper.addParam(url, 'dimension', this.formData.dimension);
        url = UrlHelper.addParam(url, 'keyword', this.formData.keyword);
        url = UrlHelper.addParam(url, 'type', this.formData.type);
        url = UrlHelper.addParam(url, 's_time', this.formData.s_time);
        url = UrlHelper.addParam(url, 'e_time', this.formData.e_time);
        url = UrlHelper.addParam(url, 'goods_type_ids', this.goods_type_ids.join(','));
        if (this.type === 1) {
            url = UrlHelper.addParam(url, 'supplier_upper_ids', this.supplier_upper_ids.join(','));
        }
        else {
            url = UrlHelper.addParam(url, 'business_ids', this.business_ids.join(','));
        }
        location.href = url;
        window._czc.push(['_trackEvent', '价格波动分析', '价格波动分析导出']);
    };
    BillHeader.prototype.getCustomer = function () {
        var _this = this;
        this.commonService
            .getShop({
            real: 1,
        })
            .then(function (res) {
            var DATA = res.data || {};
            _this.shopList = Array.isArray(DATA.data) ? DATA.data : [];
        });
    };
    BillHeader.prototype.getCategory = function () {
        var _this = this;
        this.goodService.getCategory({ level: 4 }).then(function (res) {
            var DATA = res.data || {};
            _this.categoryData = Array.isArray(DATA.data) ? DATA.data : [];
        });
    };
    BillHeader.prototype.getSupplierupper = function () {
        var _this = this;
        this.service
            .getSupplierupperCategoryList({
            has_supplier: 1,
        })
            .then(function (res) {
            res.data.data.map(function (item) {
                if (item.category_id || item.category_name) {
                    item.supplier_upper_id = 'category_id' + item.category_id;
                    item.supplier_upper_name = item.category_name;
                }
                if (item.children && item.children.length > 0) {
                    item.children.map(function (child, index) {
                        child.parent_id = item.category_id;
                        child.parent_name = item.category_name;
                    });
                }
            });
            _this.supplierList = res.data.data;
        });
    };
    __decorate([
        Prop({
            default: 1,
        })
    ], BillHeader.prototype, "type", void 0);
    __decorate([
        Watch('formData.type')
    ], BillHeader.prototype, "watchshop_id", null);
    BillHeader = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                user: 'user',
            })),
        })
    ], BillHeader);
    return BillHeader;
}(Vue));
export default BillHeader;
